import { render, staticRenderFns } from "./CityAndRegionColumn.vue?vue&type=template&id=fe42141c&scoped=true"
import script from "./CityAndRegionColumn.vue?vue&type=script&lang=js"
export * from "./CityAndRegionColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe42141c",
  null
  
)

export default component.exports